/* eslint-disable */

import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import * as XLSX from 'xlsx';
import {
  Table,
  Card,
  Button,
  Space,
  Typography,
  Tag,
  Modal,
  Row,
  Col,
  message,
  Divider,
  Image,
  Input,
  Select,
  Statistic,
  Pagination,
  DatePicker,
} from 'antd';
import locale from 'antd/es/date-picker/locale/th_TH';
import './OrderMobile.css';
import '../../components/mobile-order/MobileOrder.css';
import MobileOrderCard from '../../components/mobile-order/MobileOrderCard';
import MobileProductItem from '../../components/mobile-order/MobileProductItem';
import {
  SearchOutlined,
  ReloadOutlined,
  FileExcelOutlined,
  EyeOutlined,
  UserOutlined,
  ShopOutlined,
  CalendarOutlined,
  ShoppingCartOutlined,
  FilterOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  DollarOutlined,
} from '@ant-design/icons';
import { Timeline } from 'antd';
import { orderStatus } from '../library';
import InfoCard, { InfoRow, InfoGrid } from '../../components/info-card/InfoCard';

dayjs.extend(buddhistEra);
dayjs.locale('th');

import { ResponsiveRangePicker } from '../../components/ResponsiveDatePicker/ResponsiveDatePicker';

const { Title, Text } = Typography;

export const getStatusCategory = (order) => {
  const status = order.order_status;
  const paymentStatus = order.api_paymentstatus;

  if (status === 'PC_RCV' || paymentStatus === 'Settlement Success') {
    return 'success';
  }

  const cancelStatuses = [
    'IV_Cancel',
    'IV_EXP',
    'IV_C_Cancel',
    'IV_V_Cancel',
    'PC_C_Cancel_AC',
    'PC_C_Cancel_AT',
    'PC_V_Cancel',
  ];
  const cancelPaymentStatuses = ['Fail', 'Cancel', 'Error'];

  if (cancelStatuses.includes(status) || cancelPaymentStatuses.includes(paymentStatus)) {
    return 'cancel';
  }

  return 'pending';
};

const formatCurrency = (val) =>
  Number(val || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

const renderShopInfo = (shopName, province) => (
  <Space direction='vertical' size={0}>
    <Text strong>{shopName}</Text>
    <Text type='secondary' style={{ fontSize: '12px' }}>
      {province}
    </Text>
  </Space>
);

const renderCurrency = (val) => formatCurrency(val);
const renderCurrencyBold = (val) => (
  <Text strong type='success'>
    {formatCurrency(val)}
  </Text>
);

const productItemColumns = [
  { title: 'หน่วย', dataIndex: 'unit', render: (val) => `ชุด ${val} ชิ้น` },
  { title: 'วันหมดอายุ', dataIndex: 'expire', render: (val) => dayjs(val).format('DD MMM BBBB') },
  { title: 'จำนวน', dataIndex: 'select', render: (val) => `x ${val}` },
  {
    title: 'ยอดรวม',
    dataIndex: 'subtotal',
    align: 'right',
    render: (val) => `฿ ${Number(val).toLocaleString()}`,
  },
];

const OrderTracking = (props) => {
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);

  const [dateRange, setDateRange] = useState([dayjs(), dayjs()]);
  const [searchText, setSearchText] = useState('');

  const [statusFilter, setStatusFilter] = useState('all');

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  const [timelineModalOpen, setTimelineModalOpen] = useState(false);
  const [timelineLoading, setTimelineLoading] = useState(false);
  const [shippingTimeline, setShippingTimeline] = useState([]);

  const cardVariant = useMemo(() => {
    if (!currentOrder) return 'default';
    const cat = getStatusCategory(currentOrder);
    if (cat === 'success') return 'success';
    if (cat === 'cancel') return 'danger';
    return 'warning';
  }, [currentOrder]);

  useEffect(() => {
    fetchOrderList();
  }, []);

  const fetchOrderList = async () => {
    if (!dateRange || dateRange.length !== 2 || !dateRange[0] || !dateRange[1]) {
      message.error('กรุณาเลือกช่วงวันที่ก่อน');
      return;
    }

    const [start, end] = dateRange;
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('date_start', start.format('YYYY-MM-DD 00:00:00'));
      formData.append('date_stop', end.add(1, 'day').format('YYYY-MM-DD 00:00:00'));

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/common/getorderlistbydate`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        setOrderList(response.data.order);
        message.success('โหลดข้อมูลสำเร็จ');
      } else {
        message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderDetail = async (orderId) => {
    setModalLoading(true);

    try {
      const formData = new FormData();
      formData.append('order_id', orderId);

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/common/getorderbyid`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        setCurrentOrder(response.data.order[0]);
        setIsModalOpen(true);
      } else {
        message.error(response.data.message || 'ไม่พบข้อมูลคำสั่งซื้อ');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setModalLoading(false);
    }
  };

  const fetchTimelineTracking = async (trackingCode) => {
    if (!trackingCode) {
      message.warning('ไม่พบเลข Tracking');
      return;
    }

    setTimelineLoading(true);

    try {
      const formData = new FormData();
      formData.append('tracking_code', trackingCode);

      const response = await axios.post(
        `${props.app_hostname}/api/order/myshop/common/timelinetracking`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        setShippingTimeline(response.data.timeline || []);
        setTimelineModalOpen(true);
      } else {
        message.warning(response.data.message || 'ไม่พบข้อมูลการขนส่ง');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setTimelineLoading(false);
    }
  };

  const exportToExcel = () => {
    if (!orderList || orderList.length === 0) {
      message.warning('ไม่มีข้อมูลสำหรับส่งออก');
      return;
    }

    const ordersSheetData = orderList.map((o, idx) => ({
      '#': idx + 1,
      'Order ID': o.order_id ?? '',
      'Order Date': dayjs(o.createtime).format('YYYY-MM-DD HH:mm:ss'),
      'Buyer Name': o.buyer_shopname ?? '',
      'Buyer Province': o.buyer_shopprovince ?? '',
      'Seller Name': o.seller_shopname ?? '',
      'Seller Province': o.seller_shopprovince ?? '',
      'Sub Total': Number(o.shop_subtotal || 0),
      Shipping: Number(o.shop_shipping_markup || 0),
      Discount: Number(o.summary_discount || 0),
      'Coupon Code': o.coupon_id ?? '',
      Total: Number(o.shop_total || 0),
    }));

    const itemsRows = [];
    orderList.forEach((o) => {
      if (Array.isArray(o.orderitem)) {
        o.orderitem.forEach((it) => {
          if (Array.isArray(it.orderitem_pricelist)) {
            it.orderitem_pricelist.forEach((pl) => {
              itemsRows.push({
                'Order ID': o.order_id,
                Seller: o.seller_shopname,
                'Product Name': it.productitem_name,
                'Product Code': it.productitem_inter,
                'Unit/ชุด': pl.unit,
                'EXP (BE)': dayjs(pl.expire).format('DD MMM BBBB'),
                Qty: pl.select,
                Subtotal: Number(pl.subtotal || 0),
              });
            });
          }
        });
      }
    });

    const wb = XLSX.utils.book_new();
    const ws1 = XLSX.utils.json_to_sheet(ordersSheetData);
    XLSX.utils.book_append_sheet(wb, ws1, 'Orders');

    if (itemsRows.length > 0) {
      const ws2 = XLSX.utils.json_to_sheet(itemsRows);
      XLSX.utils.book_append_sheet(wb, ws2, 'OrderItems');
    }

    const [start, end] = dateRange;
    const fname = `orders_${start.format('YYYYMMDD')}_${end.format('YYYYMMDD')}.xlsx`;
    XLSX.writeFile(wb, fname);
  };

  const filteredOrders = useMemo(() => {
    return orderList.filter((order) => {
      const search = searchText.toLowerCase().trim();
      const matchesSearch =
        !search ||
        order.order_id?.toLowerCase().includes(search) ||
        order.buyer_shopname?.toLowerCase().includes(search) ||
        order.seller_shopname?.toLowerCase().includes(search);

      const matchesStatus = statusFilter === 'all' || getStatusCategory(order) === statusFilter;

      return matchesSearch && matchesStatus;
    });
  }, [orderList, searchText, statusFilter]);

  const statistics = useMemo(() => {
    const totalOrders = filteredOrders.length;
    const totalAmount = filteredOrders.reduce((sum, o) => sum + Number(o.shop_total || 0), 0);
    const totalShipping = filteredOrders.reduce(
      (sum, o) => sum + Number(o.shop_shipping_markup || 0),
      0,
    );
    const successCount = filteredOrders.filter((o) => getStatusCategory(o) === 'success').length;

    return { totalOrders, totalAmount, totalShipping, successCount };
  }, [filteredOrders]);

  const statusOptions = [
    { value: 'all', label: 'ทั้งหมด' },
    { value: 'success', label: 'สำเร็จ' },
    { value: 'pending', label: 'รอดำเนินการ' },
    { value: 'cancel', label: 'ยกเลิก' },
  ];

  const columns = [
    {
      title: '#',
      key: 'index',
      width: 60,
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'รหัสคำสั่งซื้อ',
      dataIndex: 'order_id',
      key: 'order_id',
      sorter: (a, b) => a.order_id?.localeCompare(b.order_id),
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'วันที่สั่งซื้อ',
      dataIndex: 'createtime',
      key: 'createtime',
      sorter: (a, b) => dayjs(a.createtime).unix() - dayjs(b.createtime).unix(),
      defaultSortOrder: 'descend',
      render: (text) => dayjs(text).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'ผู้ซื้อ',
      key: 'buyer',
      sorter: (a, b) => a.buyer_shopname?.localeCompare(b.buyer_shopname),
      render: (_, record) => renderShopInfo(record.buyer_shopname, record.buyer_shopprovince),
    },
    {
      title: 'ผู้ขาย',
      key: 'seller',
      sorter: (a, b) => a.seller_shopname?.localeCompare(b.seller_shopname),
      render: (_, record) => renderShopInfo(record.seller_shopname, record.seller_shopprovince),
    },
    {
      title: 'สถานะ',
      key: 'status',
      width: 180,
      filters: [
        { text: 'สำเร็จ', value: 'success' },
        { text: 'รอดำเนินการ', value: 'pending' },
        { text: 'ยกเลิก', value: 'cancel' },
      ],
      onFilter: (value, record) => getStatusCategory(record) === value,
      render: (_, record) => orderStatus(record),
    },
    {
      title: 'ยอดรวม',
      dataIndex: 'shop_subtotal',
      key: 'shop_subtotal',
      align: 'right',
      sorter: (a, b) => Number(a.shop_subtotal) - Number(b.shop_subtotal),
      render: renderCurrency,
    },
    {
      title: 'ค่าจัดส่ง',
      dataIndex: 'shop_shipping_markup',
      key: 'shop_shipping_markup',
      align: 'right',
      sorter: (a, b) => Number(a.shop_shipping_markup) - Number(b.shop_shipping_markup),
      render: renderCurrency,
    },
    {
      title: 'ส่วนลด',
      dataIndex: 'summary_discount',
      key: 'summary_discount',
      align: 'right',
      sorter: (a, b) => Number(a.summary_discount || 0) - Number(b.summary_discount || 0),
      render: (val, record) =>
        Number(val || 0) > 0 ? (
          <Space direction='vertical' size={0} style={{ textAlign: 'right' }}>
            <Text type='danger' strong>
              - {formatCurrency(val)}
            </Text>
            {record.coupon_id && (
              <Text type='secondary' style={{ fontSize: '10px' }}>
                🏷️ {record.coupon_id}
              </Text>
            )}
          </Space>
        ) : (
          '-'
        ),
    },
    {
      title: 'ยอดรวมทั้งหมด',
      dataIndex: 'shop_total',
      key: 'shop_total',
      align: 'right',
      sorter: (a, b) => Number(a.shop_total) - Number(b.shop_total),
      render: renderCurrencyBold,
    },
    {
      title: 'จัดการ',
      key: 'action',
      width: 100,
      align: 'center',
      fixed: 'right', // Pinned to right side during horizontal scroll for desktop usability
      render: (_, record) => (
        <Button
          type='primary'
          icon={<EyeOutlined />}
          size='small'
          onClick={() => fetchOrderDetail(record.order_id)}
        >
          รายละเอียด
        </Button>
      ),
    },
  ];

  const renderMobileCards = () => {
    return (
      <div className='order-mobile-view'>
        <div className='order-card-container'>
          {filteredOrders
            .slice((currentPage - 1) * pageSize, currentPage * pageSize)
            .map((record) => (
              <MobileOrderCard
                key={record.order_id}
                record={record}
                onViewDetails={fetchOrderDetail}
                headerExtra={orderStatus(record)}
                totalClass='success'
              />
            ))}
        </div>
        <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center' }}>
          <Pagination {...paginationConfig} showSizeChanger={false} size='small' />
        </div>
      </div>
    );
  };

  const paginationConfig = {
    pageSize,
    current: currentPage,
    showTotal: (total) => `รวม ${total} รายการ`,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100'],
    onChange: (page, size) => {
      setCurrentPage(page);
      setPageSize(size);
    },
  };

  const renderTimelineItems = () => {
    return shippingTimeline
      .slice()
      .reverse()
      .map((item, index) => ({
        color: index === 0 ? 'green' : 'blue',
        label: (
          <Text type='secondary' style={{ fontSize: '12px' }}>
            {item.datetime}
          </Text>
        ),
        children: (
          <div>
            <Text strong>{item.description}</Text>
            {item.location && (
              <div>
                <Text type='secondary' style={{ fontSize: '12px' }}>
                  <EnvironmentOutlined style={{ marginRight: 4 }} />
                  {item.location}
                </Text>
              </div>
            )}
          </div>
        ),
      }));
  };

  const filterBoxStyle = {
    background: '#fff',
    border: '1px solid #f0f0f0',
    borderRadius: 8,
    padding: 16,
    height: '100%',
  };

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div>
              <Title level={3} style={{ margin: 0 }}>
                <ShoppingCartOutlined style={{ color: '#1890ff', marginRight: '8px' }} />
                การจัดส่งตามคำสั่งซื้อ
              </Title>
              <Text type='secondary'>ติดตามคำสั่งซื้อทั้งหมดตามช่วงวันที่</Text>
            </div>
          </div>

          <Divider style={{ margin: '12px 0' }} />

          <Row gutter={[16, 16]}>
            <Col xs={12} sm={6}>
              <Card size='small' style={{ borderLeft: '4px solid #1890ff' }}>
                <Statistic
                  title='จำนวนคำสั่งซื้อ'
                  value={statistics.totalOrders}
                  prefix={<ShoppingCartOutlined style={{ color: '#1890ff', opacity: 0.8 }} />}
                  valueStyle={{ fontWeight: 700 }}
                />
              </Card>
            </Col>
            <Col xs={12} sm={6}>
              <Card size='small' style={{ borderLeft: '4px solid #52c41a' }}>
                <Statistic
                  title='ยอดรวมทั้งหมด'
                  value={statistics.totalAmount}
                  precision={2}
                  prefix={<span style={{ color: '#52c41a', marginRight: 4 }}>฿</span>}
                  valueStyle={{ fontWeight: 700 }}
                />
              </Card>
            </Col>
            <Col xs={12} sm={6}>
              <Card size='small' style={{ borderLeft: '4px solid #fa8c16' }}>
                <Statistic
                  title='ค่าขนส่งรวม'
                  value={statistics.totalShipping}
                  precision={2}
                  prefix={<span style={{ color: '#fa8c16', marginRight: 4 }}>฿</span>}
                  valueStyle={{ fontWeight: 700 }}
                />
              </Card>
            </Col>
            <Col xs={12} sm={6}>
              <Card size='small' style={{ borderLeft: '4px solid #13c2c2' }}>
                <Statistic
                  title='สำเร็จแล้ว'
                  value={statistics.successCount}
                  suffix={`/ ${statistics.totalOrders}`}
                  valueStyle={{ fontWeight: 700, color: '#13c2c2' }}
                />
              </Card>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={8}>
              <div style={filterBoxStyle}>
                <Space direction='vertical' size={8} style={{ width: '100%' }}>
                  <Text strong>
                    <CalendarOutlined style={{ marginRight: 4 }} />
                    ช่วงวันที่:
                  </Text>
                  <ResponsiveRangePicker
                    value={dateRange}
                    onChange={(dates) => setDateRange(dates || [null, null])}
                    style={{ width: '100%' }}
                    format='DD/MM/YYYY'
                    placeholder={['วันเริ่มต้น', 'วันสิ้นสุด']}
                    allowClear={false}
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                    locale={locale}
                    presets={[
                      {
                        label: 'วันนี้',
                        value: [dayjs().startOf('day'), dayjs().endOf('day')],
                      },
                      {
                        label: 'เมื่อวาน',
                        value: [
                          dayjs().subtract(1, 'day').startOf('day'),
                          dayjs().subtract(1, 'day').endOf('day'),
                        ],
                      },
                      {
                        label: '7 วันล่าสุด',
                        value: [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')],
                      },
                      {
                        label: '30 วันล่าสุด',
                        value: [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')],
                      },
                      {
                        label: 'เดือนนี้',
                        value: [dayjs().startOf('month'), dayjs().endOf('day')],
                      },
                      {
                        label: 'เดือนที่แล้ว',
                        value: [
                          dayjs().subtract(1, 'month').startOf('month'),
                          dayjs().subtract(1, 'month').endOf('month'),
                        ],
                      },
                    ]}
                  />
                </Space>
              </div>
            </Col>

            <Col xs={24} md={10}>
              <div style={filterBoxStyle}>
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={12}>
                    <Space direction='vertical' size={8} style={{ width: '100%' }}>
                      <Text strong>
                        <SearchOutlined style={{ marginRight: 4 }} />
                        ค้นหา:
                      </Text>
                      <Input
                        placeholder='ค้นหา Order ID, ชื่อผู้ซื้อ...'
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        allowClear
                        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                      />
                    </Space>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Space direction='vertical' size={8} style={{ width: '100%' }}>
                      <Text strong>
                        <FilterOutlined style={{ marginRight: 4 }} />
                        สถานะ:
                      </Text>
                      <Select
                        value={statusFilter}
                        onChange={setStatusFilter}
                        options={statusOptions}
                        style={{ width: '100%' }}
                        placeholder='สถานะ'
                      />
                    </Space>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xs={24} md={6}>
              <div style={{ ...filterBoxStyle, display: 'flex', alignItems: 'center' }}>
                <Space direction='vertical' size={8} style={{ width: '100%' }}>
                  <Button
                    type='primary'
                    icon={<SearchOutlined />}
                    onClick={fetchOrderList}
                    loading={loading}
                    block
                  >
                    ค้นหา
                  </Button>
                  <Button
                    icon={<FileExcelOutlined />}
                    onClick={exportToExcel}
                    disabled={!filteredOrders.length}
                    block
                    style={{
                      backgroundColor: filteredOrders.length ? '#217346' : undefined,
                      color: filteredOrders.length ? 'white' : undefined,
                      borderColor: filteredOrders.length ? '#217346' : undefined,
                    }}
                  >
                    Export Excel
                  </Button>
                </Space>
              </div>
            </Col>
          </Row>

          {props.isMobile ? (
            renderMobileCards()
          ) : (
            <div className='order-desktop-view'>
              <Table
                columns={columns}
                dataSource={filteredOrders}
                rowKey='order_id'
                loading={loading}
                pagination={paginationConfig}
                scroll={{ x: 'max-content' }}
                size='middle'
              />
            </div>
          )}
        </Space>
      </div>

      <Modal
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              width: '95%',
            }}
          >
            <Text strong style={{ fontSize: '18px' }}>
              {currentOrder?.order_id}
            </Text>
            <div style={{ textAlign: 'right' }}>
              <Text type='secondary' style={{ fontSize: '11px', display: 'block' }}>
                สถานะคำสั่งซื้อ:
              </Text>
              <div style={{ fontSize: '10px' }}>{currentOrder && orderStatus(currentOrder)}</div>
            </div>
          </div>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key='close' onClick={() => setIsModalOpen(false)}>
            ปิด
          </Button>,
        ]}
        width={props.isMobile ? '95%' : 900}
        centered
        className='custom-modal'
      >
        {currentOrder && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <InfoCard variant={cardVariant} compact>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Text>ผู้ซื้อ</Text>
                <Text type='secondary'>{currentOrder.buyer_shopname}</Text>
              </div>
            </InfoCard>

            <InfoCard variant={cardVariant} compact>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Text>ผู้ขาย</Text>
                <Text type='secondary'>{currentOrder.seller_shopname}</Text>
              </div>
            </InfoCard>

            <InfoCard
              title={`คำสั่งซื้อ: ${currentOrder.order_id}`}
              icon={<ShoppingCartOutlined />}
              variant={cardVariant}
            >
              {currentOrder.orderitem?.map((item, idx) => (
                <MobileProductItem
                  key={item.productitem_id || idx}
                  item={item}
                  idx={idx}
                  appHostname={props.app_hostname}
                />
              ))}
            </InfoCard>

            <InfoCard title='สรุปยอดชำระ' icon={<DollarOutlined />} variant={cardVariant}>
              <InfoRow
                label='ยอดรวมสินค้า'
                value={`${formatCurrency(currentOrder.shop_subtotal)} ฿`}
              />
              <InfoRow
                label='ค่าจัดส่ง'
                value={`${formatCurrency(currentOrder.shop_shipping_markup)} ฿`}
              />
              {Number(currentOrder.summary_discount || 0) > 0 && (
                <InfoRow
                  label='ส่วนลด'
                  value={`- ${formatCurrency(currentOrder.summary_discount)} ฿`}
                  valueColor='red'
                />
              )}
              {currentOrder.coupon_id && (
                <InfoRow
                  label='โค้ดส่วนลดที่ใช้'
                  value={
                    <Space size={4} wrap>
                      {currentOrder.coupon_id.split(',').map((c) => (
                        <Tag color='cyan' key={c.trim()} style={{ margin: '2px 0' }}>
                          🏷️ {c.trim()}
                        </Tag>
                      ))}
                    </Space>
                  }
                />
              )}
              <InfoRow
                label='ยอดรวมทั้งหมด'
                value={`${formatCurrency(currentOrder.shop_total)} ฿`}
                valueColor={cardVariant === 'danger' ? 'red' : 'green'}
                bold
              />
            </InfoCard>

            <InfoCard title='ที่อยู่จัดส่ง' icon={<EnvironmentOutlined />} variant={cardVariant}>
              <InfoRow label='ผู้รับ' value={currentOrder.shipping_recievename} />
              <InfoRow label='เบอร์โทรศัพท์' value={currentOrder.shipping_telno} />
              <InfoRow label='ขนส่งโดย' value={currentOrder.courier_fullname || '-'} />
              <InfoRow
                label='หมายเลขพัสดุ'
                value={
                  currentOrder.shipping_courier_tracking_code ? (
                    <Text copyable={{ text: currentOrder.shipping_courier_tracking_code }}>
                      {currentOrder.shipping_courier_tracking_code}
                    </Text>
                  ) : (
                    '-'
                  )
                }
              />
            </InfoCard>
          </div>
        )}
      </Modal>

      <Modal
        title={
          <Space>
            <EnvironmentOutlined style={{ color: '#52c41a' }} />
            <span>สถานะการขนส่ง</span>
            {currentOrder && <Tag color='blue'>{currentOrder.order_id}</Tag>}
          </Space>
        }
        open={timelineModalOpen}
        onCancel={() => setTimelineModalOpen(false)}
        footer={[
          <Button key='close' onClick={() => setTimelineModalOpen(false)}>
            ปิด
          </Button>,
        ]}
        width={props.isMobile ? '95%' : 600}
        centered
      >
        {shippingTimeline.length > 0 ? (
          <Timeline mode='left' items={renderTimelineItems()} />
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
            <ClockCircleOutlined style={{ fontSize: 48, marginBottom: 16 }} />
            <div>ไม่มีข้อมูลการขนส่งที่จะแสดง</div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default OrderTracking;
